import {
  useApolloClient,
  useQuery,
  useLazyQuery,
  LazyQueryHookOptions,
} from '@apollo/react-hooks';
import { DocumentNode } from 'graphql';

import { Place } from 'scenes/Home/scenes/MerchantVenuesOnboarding/MerchantVenuesOnboarding.helpers';

import {
  GET_PLACES_SEARCH_DATA,
  PlacesSearchData,
} from 'scenes/Home/scenes/MerchantVenuesOnboarding/components/PlacesServiceSearch/PlacesServiceSearch.queries';

type SearchFields = {
  data: PlacesSearchData;
};

export const usePlacesSearch = (
  query?: DocumentNode,
  variables?: Object,
  onCompleted?: Function,
) => {
  const client = useApolloClient();

  const {
    data: placesSearchData = {} as PlacesSearchData,
  } = useQuery<PlacesSearchData>(GET_PLACES_SEARCH_DATA);

  const [
    loadPlacesServiceResults,
    { loading: searchLoading, data: getPlaces },
  ] = useLazyQuery<Place[]>(
    query as DocumentNode,
    {
      variables,
      onCompleted,
      fetchPolicy: 'no-cache',
    } as LazyQueryHookOptions,
  );

  const writeSearchCache = (data: SearchFields) => {
    client.writeData(data);
  };

  return {
    writeSearchCache,
    loadPlacesServiceResults,
    placesSearchData,
    searchLoading,
    getPlaces,
  };
};
